import {
  ReplaceAllInstances,
  enumsCashback,
  formatMoney,
} from "@itarget/shared";
import { translate } from "../../utils/translation";
import { Box, Grid, Icon, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  gridStyle: {
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
  },
  ChipStyle: {
    display: "flex",
    alignItems: "center",
    lineHeight: "normal",
    height: "fit-content",
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.shape.borderRadius,
    "& .MuiChip-label": {
      padding: 0,
      fontSize: 10,
    },
  },
  ChipDefaultStyle: {
    backgroundColor: theme.palette.chipCashback.default.color,
    "& $label": {
      color: theme.palette.chipCashback.default.text,
    },
    "& $icon": {
      color: theme.palette.chipCashback.default.text,
    },
  },
  ChipRedemptionStyle: {
    backgroundColor: theme.palette.chipCashback.redemption.color,
    "& $label": {
      color: theme.palette.chipCashback.redemption.text,
    },
    "& $icon": {
      color: theme.palette.chipCashback.redemption.text,
    },
  },
  label: {
    lineHeight: 1.08,
    fontWeight: "500",
    fontSize: theme.typography.pxToRem(12),
  },
  icon: {
    "&.material-icons": {
      fontSize: theme.typography.pxToRem(12),
    },
  },
}));

export const ChipRedemptionCashback = (props) => {
  const {
    className = "",
    payWithCashback,
    payWithCashbackPercentage = 0,
  } = props;
  const styles = useStyles();
  const {
    PRODUCTS_CAMPINGS: { PAY_WITH_CASHBACK },
  } = enumsCashback;
  const canPayWithCashback = payWithCashback === PAY_WITH_CASHBACK.ALLOWED;
  const value = payWithCashbackPercentage
    ? Number(payWithCashbackPercentage)
    : 0;
  const text = `${value}%`;

  const translations = {
    redemption: translate("Resgate até %s com seu cashback"),
  };

  if (!canPayWithCashback) return <></>;

  return (
    <Box
      flex={1}
      display="flex"
      flexWrap="wrap"
      alignItems="flex-end"
      className={`${styles.gridStyle} ${className}`}
      container
    >
      <Grid
        item
        data-testId="chip redemption"
        className={`${styles.ChipStyle} ${styles.ChipRedemptionStyle}`}
      >
        <Icon className={styles.icon}>all_inclusive</Icon>
        <Typography className={styles.label}>
          {ReplaceAllInstances(translations.redemption, [text])}
        </Typography>
      </Grid>
    </Box>
  );
};

export const ChipAccumulationCashback = (props) => {
  const { className = "", data = [] } = props;
  const {
    PRODUCTS_CAMPINGS: { FACTOR_TYPE },
  } = enumsCashback;
  const { toReal } = formatMoney;
  const styles = useStyles();
  const textArray = [];
  for (const productCampaign of data) {
    const symbol = productCampaign?.empresas_simbolo_moeda || "R$";
    if (productCampaign.tipo_fator === FACTOR_TYPE.MULTIPLIER) {
      textArray.push(`${(Number(productCampaign.fator) * 100).toFixed(0)}%`);
      continue;
    }
    textArray.push(
      `${symbol} ${toReal(Number(productCampaign.fator).toFixed(2))}`
    );
  }
  const text = textArray.join(" + ");

  const translations = {
    accumulation: translate("Acumule %s em cashback"),
  };

  if (data.length === 0) return <></>;

  return (
    <Box
      flex={1}
      display="flex"
      flexWrap="wrap"
      alignItems="flex-end"
      className={`${styles.gridStyle} ${className}`}
      container
    >
      <Grid
        item
        role="status"
        data-testid="chip accumulation"
        className={`${styles.ChipStyle} ${styles.ChipDefaultStyle}`}
      >
        <Icon className={styles.icon}>all_inclusive</Icon>
        <Typography className={styles.label}>
          {ReplaceAllInstances(translations.accumulation, [text])}
        </Typography>
      </Grid>
    </Box>
  );
};
